import React from 'react';
import Script from 'next/script';

export const ZacksHeadScript = () => (
  <>
    {/* Here for a Zacks deal. Needs to be on Quotes pages only */}
    <Script id="googletagscript" key="googletagscript" type="text/javascript">
      {`window.googletag = window.googletag || { cmd: [] };`}
    </Script>
    <link as="script" href="https://ad.wsod.com/site/391c5ac9e899a3f96ad04ca51ea98cc2/0.0.async/" rel="preload" />
    <Script async key="wsod script" src="https://ad.wsod.com/site/391c5ac9e899a3f96ad04ca51ea98cc2/0.0.async/" />
  </>
);

export default ZacksHeadScript;
